import { Outlet } from 'react-router';
import { lastWeek } from '../../planner/lastWeek';
import { WeekView } from '../WeekPage';

/** The week the teacher came from stays visible under a panel and reacts live to what the panel changes. */
export default function PanelLayout() {
  const week = lastWeek();
  return (
    <>
      <WeekView key={`${week.year}-${week.week}`} target={week} />
      <Outlet />
    </>
  );
}
